<span class="custom-tooltip-text">{{ tooltip }}</span>
